export class UnexpectedError extends Error {
  constructor(message?: string) {
    super(message ? message : 'An unexpected error occurred. Please try again');
    this.name = 'UnexpectedError';
  }
}
